export default {
    id: null,
    default: null,
    options: {
        'VIP Status Update': null,
    },
};
